import {
  getErrorMessages,
  useGetLiabilityBalanceHistoryQuery,
} from "../../../../services";
import { UseLiabilityBalanceHistoryReturn } from "./types";

export const useLiabilityBalanceHistory = (
  id: number,
): UseLiabilityBalanceHistoryReturn => {
  const {
    data,
    error: queryError,
    isLoading,
    isFetching,
  } = useGetLiabilityBalanceHistoryQuery(id);

  const errorMessages = queryError ? getErrorMessages(queryError as any) : [];
  const error = errorMessages[0] ?? null;

  return {
    points: data?.points ?? [],
    payments: data?.payments ?? [],
    isLoading: isLoading || (isFetching && !data),
    error,
  };
};
